import {type CellBinding, cellData, cellStyle, RowContext, rowContextKey} from "./AgendaUtils";
import {computed, h, inject, defineComponent, type PropType, type ComputedRef} from "vue";
import {injectExecute, injectFormData} from "../../PartInjectKeys";
import {injectEnv} from "../../Environment";
import {useListStore} from "@/store/ListStore.ts";
import {Column} from "@t/agenda/Columns.ts";
import {buildDefaultFormatter, formatterOf, formatterOfColumn} from "@fd/containers/agenda/Formatters.ts";
import {CellContext, SlotFactory} from "@t/agenda/CellFormatter.ts";
import CellClick from "@fd/containers/agenda/CellClick.vue";

export default defineComponent({
	props: {
		object: {
			type: Object,
			required: true
		},
		col: {
			type: Object as PropType<Column>,
			required: true
		}
	},

	setup(props) {
		const formData = injectFormData();
		const env = injectEnv();
		const ls = useListStore();
		const findList = ls.findList;
		const findCategory = ls.findCategory;
		const execute = injectExecute();
		const rowContext = inject(rowContextKey);

		const ctx = computed<CellContext>(() => {
			let rc = rowContext.value;
			return {
				column: props.col,
				itemKey: rc.itemKey,
				primaryKey: rc.primaryKey,
				index: rc.index,
				object: rowContext.value.object,
				actionLink: (content:SlotFactory, action:string, srcType:number, params:Record<string, any>) => {
					return () => {
						return h(CellClick, { action: action, object: props.object, srcType, data: params, col: props.col}, content);
					};
				}
			};
		});

		const content = computed<SlotFactory>(() => {
			const data = cellData(props.object, props.col, formData);
			const f = formatterOfColumn(props.col);
			return f.format(ctx.value, ...data);
		});

		const attributes = computed<CellBinding|null>(() => {
			return { style: cellStyle(props.col) };
		});

		function contentRender() {
			return h('td', attributes.value, content.value());
		}

		return contentRender;
	}
});
